import SimpleToast from "~/components/molecules/dialogs/toast/SimpleToast.vue";

export type ToastType = 'success' | 'error' | 'canceled'

export const openToast = (toastType: ToastType, message: string) => {
    const {$open} = useNuxtApp()
    $open<any>(SimpleToast, {
        message,
        toastType
    })
}